import React, {useState} from 'react';
import {useAlerts} from '../ui/alert';
import {getDateOrEmpty, toTitleCase} from '../utils/utils';
import {log} from '../utils/logs';

import {Row, Col, Box, Button} from 'adminlte-2-react';
import {DateRangeInput} from '../ui/DateRangeInput';
import {Alert} from '../ui/alert';
import {Content} from '../ui/Content';
import config from '../config';
import {EmpresaAutocomplete} from '../ui/EmpresaAutocomplete';
import {fechaMinimaPraReporteBusquedaYEstado} from '../utils/constants';

const queryString = require('query-string');

export const ReporteEstado = ({history, token}) => {
  const dateForInicio = new Date(fechaMinimaPraReporteBusquedaYEstado);

  const [inicio, setInicio] = useState(dateForInicio);
  const [empresaOption, setEmpresaOption] = useState(null);

  const today = new Date();
  const dateForFin = dateForInicio > today ? dateForInicio : today;

  const [fin, setFin] = useState(dateForFin);

  const {topAlert} = useAlerts();

  const submit = () => {
    const params = queryString.stringify({
      userToken: token.raw,
      fechaInicio: getDateOrEmpty(inicio),
      fechaFin: getDateOrEmpty(fin),
      empresaId: empresaOption?.value,
    });
    log({'submit.params': params});

    const baseUrl = config.api.baseUrl;

    const exportUrl = `${baseUrl}/v1/oportunidad/reporte/estado/excel?${params}`;

    window.open(exportUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Content title="Reporte de estado" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Row>
        <Col xs="12" md="10" mdOffset="1">
          <Box>
            <Alert
              title={'Restriccion de reporte'}
              type={'warning'}
              text={`Solo se tendra en cuenta las oportunidades creadas a partir del ${getDateOrEmpty(
                fechaMinimaPraReporteBusquedaYEstado,
              )}`}
              closable={false}
            />
            <div className="form-group">
              <EmpresaAutocomplete
                label="Empresa"
                token={token}
                initialSelectedEmpresaLabel={
                  !empresaOption || empresaOption?.value == null
                    ? 'Sin empresa seleccionada'
                    : toTitleCase(empresaOption?.label)
                }
                onSelectEmpresa={empresa => {
                  setEmpresaOption({
                    value: empresa.idNumerico,
                    label: empresa.nombre,
                  });
                }}
              />

              <label>Fecha</label>

              <DateRangeInput
                showLabels
                labelStyle={{fontWeight: 'normal'}}
                inicio={inicio}
                setInicio={setInicio}
                fin={fin}
                setFin={setFin}
                xs={12}
                md={12}
                minDate={new Date(fechaMinimaPraReporteBusquedaYEstado)}
              />
            </div>
            <div style={{float: 'right'}}>
              <div style={{display: 'inline-block', marginRight: 10}}>
                <Button
                  type="primary"
                  text="Filtrar"
                  onClick={submit}
                  disabled={!inicio || !fin || !empresaOption?.value}
                />
              </div>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
